import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { beemindLogoBackground } from '../svg/beemind-logo';
import { useNavigate } from 'react-router-dom';

const LandingPage: React.FC<{}> = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div className='first-fold'>
        <div className='copy'>
          <p className='big-phrase'>
            Wir sind
            <br /> BeeMind.
          </p>

          <p className='catch-phrase'>{`// Software, die funktioniert.`}</p>
        </div>
        <div className='first-fold-background'>{beemindLogoBackground}</div>
        <div className='links-container'>
          <div className='left-links'>
            <p onClick={() => navigate('/team')}>Team</p>{' '}
            <p onClick={() => navigate('/contact')}>Kontakt</p>
          </div>
          <div
            className='right-links'
            onClick={() => navigate('/projects')}
          >
            <p>Projekte</p>
            <FontAwesomeIcon icon={faAngleRight} style={{ margin: '0 6px' }} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LandingPage;
